// Preview unavailable card. Extracted verbatim from AuditPreview.jsx (W2b).
import { Link } from "react-router-dom";

export default function PreviewError({ error }) {
  return (
    <div className="sf-container" style={{ padding: "80px 24px" }} data-testid="preview-error">
      <div className="sf-card">
        <div className="sf-eyebrow" style={{ color: "var(--sf-gold)" }}>Preview unavailable</div>
        <p style={{ marginTop: 10 }}>{error}</p>
        <Link to="/audit" className="sf-btn-secondary" data-testid="preview-restart-link">Start a new audit</Link>
      </div>
    </div>
  );
}
